// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import UserIcon from 'components/atoms/UserIcon'
import LabelStatus from 'components/atoms/LabelStatus'
import OptimizedImage from 'components/atoms/OptimizedImage'
import LabelBorder from 'components/atoms/LabelBorder'
import Path from 'routes/path'

const LabelStatusWrap = styled.div`
  margin-left: ${spacing.small_2}px;
  margin-top: ${spacing.small}px;
  display: inline-block;
  ${mediaMin.phone`
    margin-left: 0;
    display: block;
  `};
`
const LabelStatusWrapChange = styled.div`
  margin-left: 4px;
  margin-top: ${spacing.small}px;
  display: inline-block;
  ${mediaMin.phone`
    margin-left: 0;
    display: block;
  `};
`
const ReservationListImage = styled.div`
  position: relative;
  padding-top: 66.666%;
  margin-top: ${spacing.medium}px;
  border-radius: ${borderRadius}px;
  overflow: hidden;
  ${mediaMin.phone`
    width: 138px;
    height: 92px;
    padding-top: 0;
    min-height: 92px;
    overflow: hidden;
    float: left;
    margin-top: 0;
    margin-left: ${spacing.medium_2}px;
  `};
`
const ReservationListItemInner = styled.a`
  display: block;
  padding: ${spacing.medium_2}px 0;
  ${mediaMin.phone`
    padding: ${spacing.medium_2}px ${spacing.medium}px;
  `} &::after {
    ${mediaMin.phone`
      clear: both;
      content: '';
      display: block;
    `};
  }
`
const ResponseRequestPc = styled.div`
  color: ${Colors.red};
  font-size: ${fontSize.small_2}px;
  display: none;
  ${mediaMin.phone`
    clear: both;
    display: block;
    padding-top: ${spacing.small_3}px;
  `};
`
const ResponseRequestPcEm = styled.em`
  font-weight: bold;
`
const ReservationListDetail = styled.div`
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    width: calc(100% - 288px);
    overflow: hidden;
    margin-top: 0;
    margin-left: ${spacing.small_3}px;
    float: left;
  `};
`
const ReservationListIcons = styled.div`
  margin-top: -${spacing.small}px;
  margin-left: -${spacing.small}px;
  ${mediaMin.phone`
    width: 112px;
    float: left;
    margin-left: 0;
    padding-top: ${spacing.small}px;
  `};
`
const ResponseRequestSp = styled.div`
  color: ${Colors.red};
  font-size: ${fontSize.small_2}px;
  display: block;
  margin-top: ${spacing.small}px;
  padding-left: ${spacing.small}px;
  line-height: 1.4;
  text-indent: -12px;
  ${mediaMin.phone`
    clear: both;
    display: none;
    padding-left: 0px;
  `};
`
const ResponseRequestSpEm = styled.em`
  font-weight: bold;
`
const ReservationListBodyTitle = styled.h2`
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${Colors.black};
`
const HostInformation = styled.div`
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    margin-top: ${spacing.small_2}px;
    display: table;
  `} &::after {
    clear: both;
    content: '';
    display: block;
  }
`
const HostInformationDetail = styled.dl`
  display: table-cell;
  padding-left: ${spacing.small}px;
  vertical-align: middle;
`
const HostInformationDetailShoulder = styled.dt`
  font-size: ${fontSize.small_2}px;
  color: ${Colors.gray9};
`
const Icon = styled.i`
  font-size: 11px;
  color: ${Colors.yellow};
`
const HostInformationDetailCompany = styled.dd`
  margin-top: ${spacing.tiny}px;
  color: ${Colors.black};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
const HostInformationHeading = styled.div`
  display: table-cell;
`
const SpaceInformation = styled.div`
  font-size: ${fontSize.small_2}px;
  margin-top: ${spacing.small_3}px;
  color: ${Colors.black};
  ${mediaMin.phone`
    position: relative;
  `};
`
const ReserveDate = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
const FeeInformation = styled.div`
  margin-top: ${spacing.tiny}px;
  position: relative;
  ${mediaMin.phone`
    margin-top: 4px;
  `};
`
const Fee = styled.div`
  display: inline-block;
`
const SubText = styled.div`
  display: inline-block;
  color: ${Colors.gray9};
  padding-left: ${spacing.tiny}px;
  font-size: ${fontSize.tiny}px;
`
const SubTextId = styled.div`
  color: ${Colors.gray9};
`
const PayType = styled.div`
  display: inline-block;
  padding-left: 4px;
  margin-left: 4px;
  border-left: 1px solid ${Colors.grayE};
`
const ReservedId = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`

export type PropTypes = {
  roomName: string,
  color: string,
  thumbnail: string,
  ownerName?: string,
  paymentMethodText: string,
  id: number,
  uid: string,
  reservedDateText: string,
  totalAmount: string,
  dueDate: string,
  topHost: number,
  profileImage: string,
  notReply: boolean,
  reservationPhaseTexts: string,
  unapprovedReservation: ?boolean,
  isReadMessage: boolean,
  small?: boolean,
}

export default function ReservationItem(props: PropTypes) {
  return (
    <ReservationListItemInner href={Path.reservationDetail(props.uid)}>
      <ReservationListIcons>
        <LabelBorder newArrival={!props.isReadMessage} color={props.color}>
          {props.reservationPhaseTexts}
        </LabelBorder>
        <LabelStatusWrap>
          {props.notReply && (
            <LabelStatus>
              {i18n.t('page.dashboard.reservation.notReply')}
            </LabelStatus>
          )}
        </LabelStatusWrap>
        {props.unapprovedReservation && (
          <Fragment>
            <LabelStatusWrapChange>
              <LabelStatus>
                {i18n.t('page.dashboard.reservation.reservationRequest')}
              </LabelStatus>
            </LabelStatusWrapChange>
            <ResponseRequestSp>
              ※
              <ResponseRequestSpEm>
                {props.dueDate}
                {i18n.t('page.shared.until')}
              </ResponseRequestSpEm>
              {i18n.t('page.dashboard.reservation.reservationRequestGuide')}
            </ResponseRequestSp>
          </Fragment>
        )}
      </ReservationListIcons>
      <ReservationListImage>
        <OptimizedImage
          src={props.thumbnail}
          alt={props.roomName}
          type="cover"
        />
      </ReservationListImage>
      <ReservationListDetail>
        <ReservationListBodyTitle>{props.roomName}</ReservationListBodyTitle>
        <HostInformation>
          <HostInformationHeading>
            <UserIcon
              src={props.profileImage}
              alt={props.ownerName}
              small={props.small}
            />
          </HostInformationHeading>
          <HostInformationDetail>
            {props.topHost === 1 && (
              <HostInformationDetailShoulder>
                <Icon className="icon-spm-top_host" />
                {i18n.t('page.dashboard.reservation.tophost')}
              </HostInformationDetailShoulder>
            )}
            <HostInformationDetailCompany>
              {props.ownerName}
            </HostInformationDetailCompany>
          </HostInformationDetail>
        </HostInformation>
        <SpaceInformation>
          <ReserveDate>{props.reservedDateText}</ReserveDate>
          <FeeInformation>
            {props.totalAmount && (
              <Fee>
                {props.totalAmount}
                <SubText>{i18n.t('page.dashboard.reservation.taxIn')}</SubText>
              </Fee>
            )}
            {props.paymentMethodText && (
              <PayType>{props.paymentMethodText}</PayType>
            )}
            <ReservedId>
              <SubTextId>
                {i18n.t('page.dashboard.reservation.reservedId')}
                {props.id}
              </SubTextId>
            </ReservedId>
          </FeeInformation>
        </SpaceInformation>
      </ReservationListDetail>
      {props.unapprovedReservation && (
        <ResponseRequestPc>
          ※
          <ResponseRequestPcEm>
            {props.dueDate}
            {i18n.t('page.shared.until')}
          </ResponseRequestPcEm>
          {i18n.t('page.dashboard.reservation.reservationRequestGuide')}
        </ResponseRequestPc>
      )}
    </ReservationListItemInner>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationItem/index.jsx